module.exports = __webpack_public_path__ + "frontend/images/favicons/android-chrome-192x192.png?becabd026759978c55e093d33d35c1e1";